import { render, staticRenderFns } from "./IconStateIndicator.global.vue?vue&type=template&id=70561615&scoped=true&lang=pug&"
import script from "./IconStateIndicator.global.vue?vue&type=script&lang=ts&"
export * from "./IconStateIndicator.global.vue?vue&type=script&lang=ts&"
import style0 from "./IconStateIndicator.global.vue?vue&type=style&index=0&id=70561615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70561615",
  null
  
)

export default component.exports